module.exports = __webpack_public_path__ + "img/comp-31.ada6d2dc.png";